import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import { session } from 'wix-storage';
import { getLoggedInUser } from 'public/users.js'
import { searchDomain2, suggest } from 'backend/domainSearch';
import { TLD_NOT_SUPPORTED, validateDomain, SHORT_DOMAIN, LONG_DOMAIN, NOT_VALID, getTldForPurchase, prices } from 'public/validate'
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('domains', 19, { msid: '2d8a1acf-e08f-4991-b173-319d1c033323' });

let loadMore = 5;
let url = wixLocation.url
let repeaterData = [];
let startTimeView
$w.onReady(function () {
	pageEvents();
});

async function pageEvents() {
	$w('#input1').focus();
	hideResults();
	inputDomainEvents();
	resultRepeaterEvents();
	if (wixWindow.formFactor === 'Desktop') { stickyHeaderEvents(); }
}

async function inputDomainEvents() {
	$w('#input1').focus();
	$w('#input1').onKeyPress(async (e) => {
		hideResults()
		$w('#xIcone').show();
		let inputDomain = $w('#input1').value;
		await validateInput(e.key)
		if (e.key === 'Enter') { setTimeout(() => { searchForDomain(); }, 600) }
		if ($w('#input1').value === '') { hideResults() }
	});
	$w('#xIcone').onClick(() => {
		hideResults();
		$w('#input1').value = ''
	});
	$w('#gXIcone').onClick(() => {
		hideResults()
		$w('#input1').value = ''
		$w('#gXIcone').hide()
	});
	$w('#searchDomain').onClick(() => { setTimeout(() => { searchForDomain(); }, 600) });
}

async function resultRepeaterEvents() {
	$w('#suggestionsrepeater').onItemReady(($item, itemData, index) => {
		$item('#domainSuggestion').text = itemData.domain;
		$item('#domainPrice').text = `from $${itemData.price}/year `
		$w('#suggestionsrepeater').expand();
		if (index === 0) {
			$item('#getIt').show();
			$item('#recomended').show();
			$item('#hoverBox').style.backgroundColor = '#F2F4F5';
		}
		$item('#repeaterItem').onMouseIn(async () => {
			$w('#suggestionsrepeater').forEachItem(($Otheritem, OtheritemData, Otherindex) => {
				if (index !== Otherindex) {
					$Otheritem('#hoverBox').style.backgroundColor = '#FFFFFF'
					$Otheritem('#getIt').hide();
				}
			})
			$item('#hoverBox').style.backgroundColor = '#F2F4F5'
			$item('#getIt').show();
		});
		$item('#repeaterItem').onMouseOut(async () => {
			$item('#hoverBox').style.backgroundColor = '#FFFFFF'
			$item('#getIt').hide()
		});
		$item('#getDomainBtn').onClick(() => {
			startTimeView = new Date();
			getDomain(`${itemData.price}/year `, itemData.domain, index + 1, 'suggestion')
		})
		$item('#getIt').onClick(() => {
			startTimeView = new Date();
			getDomain(`${itemData.price}/year `, itemData.domain, index + 1, 'suggestion')
		})
		if (index >= loadMore) {
			$w('#loadMore').expand();
			$item('#repeaterItem').collapse()
		}
	});

	$w('#loadMore').onClick(async () => {
		loadMore += 5;
		let data = repeaterData
		$w('#suggestionsrepeater').data = data.slice(0, loadMore)
		let result = data.slice(loadMore - 5, loadMore)
		$w('#suggestionsrepeater').forEachItem(($item, itemData, index) => {
			if (index < loadMore) { $item('#repeaterItem').expand() }
		})
		if (loadMore >= repeaterData.length) { $w('#loadMore').collapse() }

		try {
			const biEventObject = { evid: 953, result: JSON.stringify(result), searchTerm: $w('#input1').value };
			await biLogger.log(biEventObject);
		} catch (err) {
			console.log('load more BI event ERR', err)
		}
	});
}

async function stickyHeaderEvents() {
	$w('#stickyHeaderAnchor').onViewportLeave(() => { $w('#stickyHeader').show() })
	$w('#stickyHeaderAnchor').onViewportEnter(() => { $w('#stickyHeader').hide() })
	$w('#input2').onKeyPress(async (e) => {
		if (e.key === 'Enter') {
			$w('#input1').value = $w('#input2').value;
			$w('#input2').value = '';
			$w('#stickyHeader').hide()
			await validateInput()
			setTimeout(() => { searchForDomain(); }, 600)
			$w('#columnStrip4').scrollTo();
		}
	});

	$w('#input2').onFocus(() => { hideResults() })
	$w('#headerSearch').onClick(async () => {
		$w('#input1').value = $w('#input2').value;
		$w('#input2').value = '';
		$w('#stickyHeader').hide();
		await validateInput()
		setTimeout(() => { searchForDomain(); }, 600)
		$w('#columnStrip4').scrollTo();
	})
}

async function validateInput(e) {
	setTimeout(async () => {
		let inputDomain = $w('#input1').value
		if (inputDomain.startsWith('https://')) {
			$w('#input1').value = inputDomain.replace('https://', '');
			$w('#textError').text = "Enter domain without 'https://'."
			$w('#textError').expand();
		} else if (inputDomain.startsWith('http://')) {
			$w('#input1').value = inputDomain.replace('http://', '');
			$w('#textError').text = "Enter domain without 'http://'."
			$w('#textError').expand();
		} else if (e) {
			if ((e.match(/^([-a-zA-Z0-9\.]+)$/) === null)) {
				$w('#input1').value = inputDomain.replace(`${e}`, '');
				$w('#textError').text = 'Enter letters, numbers, periods and hyphens only.'
				$w('#textError').expand();
			} else if (e.match(/^[A-Z ]+$/) !== null) {
				$w('#input1').value = inputDomain.toLocaleLowerCase();
			}
		}
	}, 500)
}
let fire = true
async function searchForDomain() {
	let startTime, endTime, type, seconds;
	startTime = new Date();
	if (fire) {
		try {
			const biEventObjectSearch = { evid: 950, text: $w("#input1").value };
			await biLogger.log(biEventObjectSearch);
		} catch (err) {
			console.log('search domain BI event ERR', err)
		}
	}
	hideResults()
	repeaterData = [];

	$w('#preloader').show();
	$w('#repeaterMsg').collapse();
	$w('#suggestionsrepeater').data = [];
	let domainName = $w("#input1").value;
	domainName = domainName.replace('www.', '')

	if (!domainName) {
		$w('#preloader').hide();
		return;
	}
	if (!$w('#textError').collapsed) {
		$w('#preloader').hide();
		return;
	}
	$w('#textError').collapse();

	if (domainName.length < 3 || domainName.startsWith('.')) {
		$w('#preloader').hide();
		$w('#textError').text = 'Type a domain that includes at least 3 characters.';
		$w('#input1').focus()
		$w('#textError').expand();
		return;
	}

	if (domainName.split(".").length - 1 > 1 && !domainName.endsWith(".co.uk") && !domainName.endsWith(".com.br")) {
		$w('#preloader').hide();
		$w('#textError').text = 'Subdomains are not available.';
		$w('#input1').focus()
		$w('#textError').expand();
		return;
	}

	if (domainName.match(/^([-a-zA-Z0-9\.]+)$/) === null) { domainName = await lookForTld(domainName); }
	if (!domainName.includes('.')) {
		$w('#input1').value = domainName + '.com'
		fire = false
		searchForDomain()
		return;
	}

	try {
		let sanitizedDomain = await validateDomain(`${domainName}`)

		try {
			let results = await searchDomain2(domainName)
			if (results.available) {
				let domain, price;
				$w('#searchDomain').hide();
				$w('#getINow').show();

				$w('#input1').style.borderColor = '#098961';
				$w('#input1').style.color = '#098961';
				$w('#xIcone').hide();
				$w('#gXIcone').show();
				$w('#preloader').hide();
				if (domainName.split('.').length > 2) { domain = `${domainName.split('.')[1]}.${domainName.split('.')[2]}` } else { domain = domainName.split('.')[1] }
				price = await prices[domain];
				wixWindow.formFactor === 'Desktop' ? $w("#textError").text = `Good news! ${domainName} can be yours right now. From $${price}/year` :
					$w("#textError").text = `Good news! ${domainName} can be yours right now. 
					From $${price}/year`

				$w("#textError").expand();
				$w('#getINow').onClick(() => {
					getDomain(`${price}/year`, domainName, 0, 'available')
				})
				endTime = new Date();
				let timeDiff = endTime - startTime; //in ms
				type = "available";
				try {
					const biEventObject = { evid: 951, responseSpeed: timeDiff, result: domainName, searchTerm: domainName, type: type };
					await biLogger.log(biEventObject);
				} catch (err) {
					console.log('search available BI event ERR', err)
				}
			} else {
				let res = await suggest(sanitizedDomain);
				let domain;
				if (res.suggestions.length > 0) {
					const withIds = res.suggestions.map((item, index) => {
						if (item.domain.split('.').length > 2) {
							domain = `${item.domain.split('.')[1]}.${item.domain.split('.')[2]}`
						} else {
							domain = item.domain.split('.')[1]
						}
						let priceOfDomain = prices[domain]
						item.price = priceOfDomain
						item._id = index.toString();
						return item;
					});
					repeaterData = withIds
					$w('#preloader').hide();
					$w('#suggestionsrepeater').data = [];
					$w('#suggestionsrepeater').data = await withIds.slice(0, 6);
					$w("#repeaterMsg").text = domainName + " is taken. Choose one of the great options below.";
					$w("#repeaterMsg").expand();
					$w('#xIcone').show();

					endTime = new Date();
					let timeDiff = endTime - startTime; //in ms
					type = "suggestions";
					try {
						const biEventObject = { evid: 951, responseSpeed: timeDiff, result: JSON.stringify($w('#suggestionsrepeater').data), searchTerm: domainName, type: type };
						await biLogger.log(biEventObject);
					} catch (err) {
						console.log('suggested domains result BI event ERR', err)
					}
				} else {
					$w("#repeaterMsg").text = domainName + " isn’t available. Search for another domain name.";
					$w("#repeaterMsg").expand();
					$w('#xIcone').show();
					$w('#preloader').hide();
				}

			}

		} catch (err) {
			console.error('inner try error: ', err);
			endTime = new Date();
			let timeDiff = endTime - startTime; //in ms

			type = "error";
			try {
				const biEventObject = { evid: 951, responseSpeed: timeDiff, result: err, searchTerm: domainName, type: type };
				await biLogger.log(biEventObject);
			} catch (err2) {
				console.log('inner try BI event ERR', err2)
			}
		}
	} catch (err) {
		$w('#preloader').hide();
		let errorMessage = '';
		switch (err.message) {

		case TLD_NOT_SUPPORTED: {
			$w('#repeaterMsg').text = `We currently don't register ${domainName.slice(domainName.indexOf('.'))} domains. Choose any of the options below.`;
			errorMessage = `We currently don't register ${domainName.slice(domainName.indexOf('.'))} domains. Choose any of the options below.`;
			$w('#repeaterMsg').expand();
			await removeTLD(domainName);
			break;
		}
		case SHORT_DOMAIN: {
			$w('#textError').text = 'Type a domain that includes at least 3 characters.'
			errorMessage = 'Type a domain that includes at least 3 characters.'
			$w('#textError').expand();
			break;
		}
		case LONG_DOMAIN: {
			$w('#textError').text = 'Type a domain that includes no more than 63 characters.'
			errorMessage = 'Type a domain that includes no more than 63 characters.'
			$w('#textError').expand();
			break;
		}
		case NOT_VALID: {
			$w('#textError').text = 'Enter letters, numbers, periods and hyphens only.'
			errorMessage = 'Enter letters, numbers, periods and hyphens only.'
			$w('#textError').expand();
			break;
		}
		}
		endTime = new Date();
		let timeDiff = endTime - startTime; //in ms

		type = "error";
		if (errorMessage.lenth < 1) {
			errorMessage = err.message
		}
		//add here
		try {
			const biEventObject = { evid: 951, responseSpeed: timeDiff, result: errorMessage, searchTerm: domainName, type: type };
			await biLogger.log(biEventObject);
		} catch (err2) {
			console.log('input domain BI event ERR', err2)
		}
	}
}

async function getDomain(price, domainName, position, type) {
	let endTime = new Date();
	let seconds = endTime - startTimeView; //in ms
	//add here
	try {
		const biEventObject = { evid: 952, responseSpeed: seconds, domain: domainName, searchTerm: $w('#input1').value, type: type, position: position };
		await biLogger.log(biEventObject);
	} catch (err2) {
		console.log('get domain BI event ERR', err2)
	}

	const success = await getLoggedInUser();
	let loggenInlink = `https://apps.wix.com/redirect-post-domain/?domainName=${domainName}&referralAdditionalInfo=Anonymous-search`;
	let anonymousLink = `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://apps.wix.com/redirect-post-domain/?domainName=${domainName}%26referralAdditionalInfo=Sign-in&referralUrl=https:%2F%2Fwww.wix.com%2Fdomain%2Fnames%3Fexperiments%3DrightClickDebug`
	if (success) { wixLocation.to(loggenInlink); } else { wixLocation.to(anonymousLink); }

}

async function removeTLD(domain) {
	let sanitizedDomain = domain.slice(0, domain.indexOf('.'));
	let res = await suggest(sanitizedDomain);
	const withIds = res.suggestions.map((item, index) => {
		if (item.domain.split('.').length > 2) {
			domain = `${item.domain.split('.')[1]}.${item.domain.split('.')[2]}`
		} else {
			domain = item.domain.split('.')[1]
		}
		let priceOfDomain = prices[domain]
		item.price = priceOfDomain
		item._id = index.toString();
		return item;
	});
	$w('#suggestionsrepeater').data = [];
	$w('#suggestionsrepeater').data = withIds;
}

async function lookForTld(domainName) {
	let finalDomain;
	let tlds = await getTldForPurchase()

	if (tlds.includes(domainName)) {
		return false
	}
	const newDomain = await tlds.find(tld => {
		const tldIndex = domainName.indexOf(tld)
		if (tldIndex !== -1 && domainName[tldIndex - 1].match(/^([-a-zA-Z0-9\.]+)$/) === null) {
			finalDomain = domainName.substr(0, tldIndex - 1) + "." + tld
			return tld;
		}
	})
	if (finalDomain) { return finalDomain } else { return domainName }
}

function hideResults() {
	fire = true;
	$w('#xIcone').hide();
	$w('#preloader').hide();
	$w('#gXIcone').hide();
	$w('#textError').collapse();
	$w('#getINow').hide();
	$w('#searchDomain').show();
	$w('#input1').style.borderColor = '#323232';
	$w('#input1').style.color = '#323232';
	$w('#loadMore').collapse();
}